import React, { useEffect, useState } from "react";
import { useAuth } from "../../../context/API_Client";
import { Button, Divider, Typography } from "@mui/material";
import SelectedPsps from "./SelectedPsps";
import CustomButton from "../../../reusableComponents/CustomButton";
import "./gatewayStyle.css";

const ConfigurePaymentOptions = (props) => {
  const pspsToConfigure = props.pspsToConfigure;
  const [shown, setShown] = useState(false);
  const [toggled, setToggled] = useState(false);
  const [off, setOff] = useState(false);
  const handlePreview = () => {
    props.showPreview(!props.preview);
  };

  const [atleastOneClicked, setAtleastOneClicked] = useState(true);

  useEffect(() => {
    setAtleastOneClicked(true);
    for (let i = 0; i < props.paymentOptionsIds?.length; i++) {
      if (props?.paymentOptionsIds[i]?.Ids?.length == 0)
        setAtleastOneClicked(false);
    }
  }, [props.paymentOptionsIds]);
  return (
    <>
      {props.pspsToConfigure?.length === 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            padding: "10%",
          }}
        >
          <img
            src="/assets/EmptyStateIcon.svg"
            style={{
              height: "131px",
              justifyContent: "center",
            }}
          />
          <div
            style={{
              display: "flex",
              marginTop: "20px",
              justifyContent: "center",
            }}
          >
            <Typography style={{ fontSize: "17px" }} variant="h7">
              Add Payment Gateway
            </Typography>
          </div>

          <div
            style={{
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Typography
              variant="body1"
              style={{
                color: "var(--text-medium, rgba(1, 1, 2, 0.60))",
                fontSize: "14px",
              }}
            >
              Please add payment gateway to get started with the platform
            </Typography>
          </div>
        </div>
      ) : (
        <div
          style={{
            padding: "20px",
            display: "flex",

            alignItems: "center",
          }}
        >
          <div style={{ display: "flex" }}>
            <div>
              <div style={{ display: "flex", gap: "4px" }}>
                <img src="/assets/stars.svg" style={{ marginTop: "1px" }} />
                <Typography className="gatewayHeading">
                  Selected Gateway
                </Typography>
              </div>
              <div style={{ width: "119%", overflowY: "auto", height: "56vh" }}>
                {pspsToConfigure?.map((obj, index) => (
                  <SelectedPsps
                    index={index}
                    obj={obj}
                    getMethodsForPspAndType={props.getMethodsForPspAndType}
                    toggled={toggled}
                    setToggled={setToggled}
                    preview={props.preview}
                    showPreview={props.showPreview}
                    paymentOptions={props.paymentOptions}
                    setPaymentOptions={props.setPaymentOptions}
                    paymentOptionsIds={props.paymentOptionsIds}
                    setPaymentOptionsIds={props.setPaymentOptionsIds}
                    shown={shown}
                    setShown={setShown}
                    off={off}
                    setOff={setOff}
                    storeOptions={props.storeOptions}
                    setStoreOptions={props.setStoreOptions}
                  />
                ))}
              </div>
            </div>
            <span
              style={{
                marginLeft: "50px",
                marginTop: "-22px",
                marginBottom: "-22px",
              }}
            >
              <Divider orientation="vertical" color="#C2C2C2" />
            </span>
          </div>

          {!toggled && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <img
                src="/assets/EmptyStateIcon.svg"
                style={{
                  height: "120px",

                  justifyContent: "center",
                }}
              />
              <div
                style={{
                  display: "flex",
                  marginTop: "20px",
                  justifyContent: "center",
                }}
              >
                <Typography style={{ fontSize: "17px" }} variant="h7">
                  {!atleastOneClicked ? (
                    <>Add Payment Options</>
                  ) : (
                    <>Payment Options added</>
                  )}
                </Typography>
              </div>
              {!atleastOneClicked && (
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      color: "var(--text-medium, rgba(1, 1, 2, 0.60))",
                      fontSize: "14px",
                      textAlign: "center",
                    }}
                  >
                    Please add atleast one payment option before you see the
                    preview
                  </Typography>
                </div>
              )}
              {props.paymentOptions?.length > 0 && (
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    marginTop: "10px",
                  }}
                >
                  <CustomButton
                    text={"See Preview"}
                    type={"primary"}
                    variant={"contained"}
                    size={"md"}
                    onClick={handlePreview}
                    disabled={!atleastOneClicked}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ConfigurePaymentOptions;
